import React from 'react';
import { Teaser, Typography, Wrapper } from '@adac-mp/components';
import { ViewportType } from '@adac-mp/components/src/hooks/useViewport';
import {
	ITypeTeaserFields,
	ITypeVignettesOrderCompletedFields,
	ITypeVignettesOrderManagementFields,
} from '@adac-mp/shared';
import { Entry } from 'contentful';

interface IRenderTeasers {
	viewport: ViewportType | undefined;
	currentLabels?: ITypeVignettesOrderCompletedFields | ITypeVignettesOrderManagementFields;
	teaserItems: Entry<ITypeTeaserFields>[];
}

export const renderTeasers = ({ viewport, currentLabels, teaserItems }: IRenderTeasers) => (
	<Wrapper
		className="bg-gray-warm"
		style={{
			paddingBottom: viewport === 'desktop' ? '64px' : '48px',
			paddingTop: viewport === 'desktop' ? '64px' : '48px',
		}}>
		<Typography className="text-center md:mb-6 mb-4" component="h2" size="h2" color="title" variant="header">
			{currentLabels?.teaserHeadline || 'Unsere ADAC Empfehlungen'}
		</Typography>
		<section
			className={`${
				teaserItems.length > 3 ? 'md:grid md:grid-cols-2' : 'md:flex-row'
			} flex flex-col gap-5 self-center md:max-w-10/12`}>
			{teaserItems.map((teaser: any, index) => {
				return (
					teaser.content && (
						<Teaser
							key={`${teaser.headline}: ${index}`}
							className={teaserItems.length > 1 ? 'basis-1/2' : 'basis-full'}
							teasersCount={teaserItems.length}
							image={{
								src: teaser.image[0].secure_url,
								alt: teaser.image[0].alt,
							}}
							title={teaser.headline}
							description={teaser.content}
							link={{
								label: teaser.buttonLabel,
								href: teaser.buttonLink,
							}}
							tracking={{
								teaser_view: {
									label: teaser.headline,
									element: 'Confirmation Page',
								},
							}}
						/>
					)
				);
			})}
		</section>
	</Wrapper>
);
